import type { ReactNode } from 'react';

import eavierLogo from '@/assets/images/eavier-logo.png';
import PageMeta from '@/shared/components/PageMeta';
import type { Props as PageMetaProps } from '@/shared/components/PageMeta';

import styles from './index.module.scss';

type Props = {
  readonly children: ReactNode;
  readonly pageMeta: PageMetaProps;
  readonly title?: ReactNode;
  readonly subtitle?: ReactNode;
  readonly footer?: ReactNode;
};

const EavierMobileLoginLayout = ({
  children,
  pageMeta,
  title = '伊维智能',
  subtitle,
  footer,
}: Props) => (
  <main className={`eavier-auth-theme ${styles.page}`}>
    <PageMeta {...pageMeta} />
    <section className={styles.shell}>
      <header className={styles.header}>
        <img className={styles.logoImage} src={eavierLogo} alt="" aria-hidden="true" />
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.subtitle}>{subtitle ?? '员工登录账号'}</p>
      </header>

      <div className={styles.formArea}>{children}</div>
      {footer && <footer className={styles.footer}>{footer}</footer>}
    </section>
  </main>
);

export default EavierMobileLoginLayout;
